import React, { useState, useMemo } from "react";

import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledTooltip,
} from "reactstrap";

const BadgesEllipsisSoft = ({
  objItems,
  sizePx,
  showDynamic,
  isTooltip,
  ...props
}) => {
  const [modal, setModal] = useState(false);
  const [time] = useState(new Date().getTime());

  const toggleModal = () => {
    setModal(!modal);
  };

  const total = useMemo(() => {
    if (props?.total) return props.total;

    if (showDynamic) {
      return objItems?.[0]?.name?.length <= 15 ? 2 : 1;
    }
    return 2;
  }, [objItems, showDynamic, props?.total]);

  return (
    <React.Fragment>
      <div>
        {objItems.length > total ? (
          <div className="d-flex">
            {objItems.slice(0, total).map((item, key) => (
              <div
                key={key}
                className="overflow-auto d-inline-flex"
                id={`tooltip-name-skill-${key}-${time}`}
              >
                <span className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success">
                  {item.name}
                </span>

                {isTooltip && item.name.length >= 15 && (
                  <UncontrolledTooltip
                    className="tooltip-actions"
                    placement="auto"
                    target={`tooltip-name-skill-${key}-${time}`}
                  >
                    {item.name}
                  </UncontrolledTooltip>
                )}
              </div>
            ))}
            <Dropdown
              //toggle={() => toggleModal()}
              onMouseEnter={() => toggleModal()}
              onMouseLeave={() => toggleModal()}
              isOpen={modal}
              nav={false}
              a11y={false}
            >
              <div className="d-inline-flex overflow-auto">
                <DropdownToggle
                  tag="span"
                  className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success"
                >
                  +{objItems.length - total}
                </DropdownToggle>
              </div>
              <DropdownMenu>
                {objItems.slice(total, objItems.length).map((item, key) => (
                  <div key={key} className="overflow-auto d-flex">
                    <span
                      color="success"
                      className={
                        (item.name.length < 10
                          ? "badge-ellipsis soft"
                          : "badge-ellipsis soft-big") +
                        " badge-ellipsis font-size-12 mx-2 my-1 badge-soft-success"
                      }
                    >
                      {item.name}
                    </span>
                  </div>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div className="d-flex">
            {objItems.map((item, key) => (
              <div
                key={key}
                className="overflow-auto d-inline-flex"
                id={`tooltip-name-skill-${key}-${time}`}
              >
                <span className="badge-ellipsis soft font-size-12 mr-2 badge-soft-success">
                  {item.name}
                </span>
                {isTooltip && item.name.length > 15 && (
                  <UncontrolledTooltip
                    className="tooltip-actions"
                    placement="auto"
                    target={`tooltip-name-skill-${key}-${time}`}
                  >
                    {item.name}
                  </UncontrolledTooltip>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default BadgesEllipsisSoft;
